import {
  IMsalContext,
  MsalAuthenticationResult,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { Link } from "react-router-dom";
import { InteractionType } from "@azure/msal-browser";
import { Loader } from "../loader";

import s from "./auth-element.module.css";

function ErrorComponent({ error }: MsalAuthenticationResult) {
  return (
    <div className={s.errorComponent}>
      <div className={s.errorContainer}>
        Atsiprašome. Įvyko klaida:
        <div>{error?.errorMessage}</div>
        <Link className="btn btn-primary btn-lg px-4 gap-3" to="/">
          Į pradžią
        </Link>
      </div>
    </div>
  );
}

function LoadingComponent(_props: IMsalContext) {
  return (
    <div className={s.loaderContainer}>
      <div>
        <Loader />
        Nukreipiama į autentifikavimo portalą...
      </div>
    </div>
  );
}

export const AuthElement = ({ children }: { children: JSX.Element }) => {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={{
        scopes: ["openid", "profile", "email"],
      }}
      errorComponent={ErrorComponent}
      loadingComponent={LoadingComponent}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
};
